import React from "react";
import UserImg from "assets/images/undraw_male_avatar_323b.svg";
import { useNavigate } from "react-router-dom";
import { useUsuario } from "App/Hooks/global/UsuarioContext";
import { Avatar, Button } from "antd";
import { Column, Row, Typography } from "core/util-styled-components";
import { useGlobal } from "App/Hooks/global/GlobalContext";
import { useMediaQueryCustom } from "App/Hooks/useMediaQueryCustom";
import { Theme } from "theme/Theme";
function UserInfo({ responsive = false }) {
  const { setBarraActiva } = useGlobal();
  const { usuario, logout } = useUsuario();
  const push = useNavigate();

  const { isTabletOrMobile } = useMediaQueryCustom();

  return (
    <Row gap="10px" padding=".5em 1em" style={{ backgroundColor: "white" }}>
      {!(responsive && isTabletOrMobile) && (
        <Avatar
          src={UserImg}
          alt="foto de perfil"
          // className="profile-img-for-navbar"
          size={"default"}
        />
      )}
      {!(responsive && isTabletOrMobile) && (
        <Column alignItems="flex-start">
          <Typography fw="bold">
            <strong>{usuario ? usuario.login_username : "Desconocido"}</strong>
          </Typography>
          <Typography variant="label">
            <Row gap=".2em">
              <i
                className="fa fa-circle"
                style={{
                  color: usuario ? Theme.colors.success : Theme.colors.error,
                  fontSize: "7px",
                }}
              />
              {usuario ? "Activo(a) ahora" : "Desconectado(a)"}
            </Row>
          </Typography>
        </Column>
      )}
      {!(responsive && isTabletOrMobile) && (
        <Button
          size="small"
          onClick={() => {
            if (usuario) {
              logout();
              setBarraActiva(false);
              push("/login");
            } else {
              setBarraActiva(false);
              push("/login");
            }
          }}
        >
          {usuario ? "Cerrar sesión" : "Iniciar sesión"}
        </Button>
      )}
    </Row>
  );
}

export default UserInfo;
